import { DatabaseType } from "~/gen/api/encrypt";

export const nonSqlDbTypes = new Set([DatabaseType.CosmosDB, DatabaseType.MongoDB])
